import * as React from 'react'

import { cn } from '#app/utils/misc.tsx'

const Input = ({
	className,
	type,
	...props
}: React.ComponentProps<'input'>) => {
	return (
		<input
			data-slot="input"
			type={type}
			className={cn(
				'cathedral-body border-cathedral-border bg-cathedral-surface ring-offset-background placeholder:text-cathedral-brown/70 focus-visible:ring-cathedral-bright aria-[invalid]:border-input-invalid flex h-11 w-full rounded-sm border px-4 py-2 text-base file:border-0 file:bg-transparent file:text-base file:font-medium focus-visible:ring-2 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 md:text-sm md:file:text-sm',
				className,
			)}
			{...props}
		/>
	)
}

export { Input }
